import { notification } from 'antd';
import React from 'react';
import { t } from '../i18n.jsx';

export function useAppNotification() {
  const [api, contextHolder] = notification.useNotification();

  const asPreLine = (value) => (
    <div style={{ whiteSpace: 'pre-line' }}>{value}</div>
  );

  const build =
    (method) =>
    ({ message, description = null, key = null, duration = 3 }) => {
      const config = { duration };

      // message: accept string or ReactNode; translate only strings and preserve new lines
      if (typeof message === 'string') {
        config.title = asPreLine(t(message));
      } else if (message != null) {
        config.title = message; // ReactNode already
        //pozor tuto by malo byt .title nie message, ale nefuguje to
      }

      // description: accept string or ReactNode; translate only strings and preserve new lines
      if (description) {
        if (typeof description === 'string') {
          config.description = asPreLine(t(description));
        } else {
          config.description = description; // ReactNode already
        }
      }

      if (key) {
        config.key = key;
      }

      return api[method](config);
    };

  const success = build('success');
  const error = build('error');
  const warning = build('warning');
  const info = build('info');

  const dismiss = (key) => api.destroy(key);

  return {
    contextHolder,
    notify: {
      success,
      error,
      warning,
      info,
      dismiss,
    },
  };
}
